import axios from "axios";

export default class Service {
    constructor() {
        this.url = "/api/Ideas/";
    }

    getClientIdeas() {
        return axios.get(this.url + "GetClientIdeas");
    }

    createIdea(idea) {
        return axios.post(this.url + "CreateIdea", idea);
    }

    editIdea(idea) {
        return axios.post(this.url + "EditIdea", idea);
    }

    deleteIdea(id) {
        return axios.post(this.url + "DeleteIdea", id);
    }

    saveOrder(ideas) {
        return axios.post(this.url + "SaveOrder", ideas);
    }
}